import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import axios from "axios";

const LeaderboardContext = createContext();

export const useLeaderboard = () => useContext(LeaderboardContext);

export const LeaderboardProvider = ({ children }) => {
  const [leaderboard, setLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = import.meta.env.VITE_APP_BASE_URL;

  useEffect(() => {
    if (leaderboard === null) {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      axios
        .get(`${baseUrl}/v2/leaderboard`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => setLeaderboard(res.data.leaderboard || res.data || []))
        .catch((err) => setError(err))
        .finally(() => setLoading(false));
    }
  }, [leaderboard, baseUrl]);

  const refetchLeaderboard = () => setLeaderboard(null);

  const resetLeaderboardState = useCallback(() => {
    setLeaderboard(null);
    setLoading(true);
    setError(null);
  }, []);

  return (
    <LeaderboardContext.Provider
      value={{
        leaderboard,
        loading,
        error,
        refetchLeaderboard,
        resetLeaderboardState,
      }}
    >
      {children}
    </LeaderboardContext.Provider>
  );
};
